import { PaymentTerm } from "@faire/web-api--source/indigofair/data/PaymentTerm";
import { ISelfServeBrandOrder } from "@faire/web-api--source/indigofair/helpcenter/ISelfServeBrandOrder";

export const orderTermIsPaymentOnShipment = (
  brandOrder: ISelfServeBrandOrder
) => {
  const paymentTerm = brandOrder.brand_order?.payment_term;
  return paymentTerm === PaymentTerm.PAYMENT_ON_SHIPMENT;
};
